<template>
  <div class="withdraw">
    <div class="content_wrap">
      <div class="content" ref="minContent">
        <!-- 第一步 -->
        <div class="part_one">
          <mt-header title="提现">
            <mt-button icon="back" slot="left" @click.native="$router.go(-1)">返回</mt-button>
          </mt-header>
          <div class="title">
            <p>账户余额（元）</p>
            <span>{{allMoney}}</span>
            <div class="prompt">
              <icon name='info-circle'></icon>
              <span>说明：目前仅支持支付宝提现，每月最多2次，每次可提现20元~50000元</span>
            </div>
          </div>
          <!-- 表单部分 -->
          <form @submit.prevent="validateSubmit">
            <!-- 支付宝账号 -->
            <div class="zfb_account">
              <p>支付宝账号</p>
              <input type="text" name="account" v-model="account" v-validate="'required|account'" :class="{'input': true, 'is-danger': errors.has('account') }">
            </div>
            <span v-show="errors.has('account')" class="help is-danger">{{ errors.first('account') }}</span>
            <!-- 姓名 -->
            <div class="zfb_name">
              <p>支付宝姓名</p>
              <input type="text" name="zfbName" v-model="zfbName" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('zfbName') }">
            </div>
            <span v-show="errors.has('zfbName')" class="help is-danger">{{ errors.first('zfbName') }}</span>
            <!-- 提现金额 -->
            <div class="money">
              <p class="money_title">提取现金</p>
              <div class="set">
                <label>¥</label><input ref="money" v-model="money" type="number" name="money" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('money') }">
              </div>
              <span v-show="errors.has('money')" class="help is-danger">{{ errors.first('money') }}</span>
              <div class="can">
                <span>可提现金额 {{takeMoney}}元</span>
                <p @click="moneyBtn">全部提现</p>
              </div>
            </div>
            <div class="tips">预计到账时间：3-7个工作日 （平台负担手续费）</div>
            <button class="primary" type="submit">下一步</button>
          </form>
        </div>
        <!-- 第二步 -->
        <div class="part_two">
          <mt-header title="提现申请">
            <mt-button icon="back" slot="left" @click="$router.go(-1)">返回</mt-button>
            <mt-button slot="right" @click="prevBtn">修改</mt-button>
          </mt-header>
          <div class="info">
            <div>
              <p class="name">支付宝账号</p>
              <p class="value">{{account}}</p>
            </div>
            <div>
              <p class="name">支付宝姓名</p>
              <p class="value">{{zfbName}}</p>
            </div>
            <div>
              <p class="name">提现金额</p>
              <p class="value">{{money}}元</p>
            </div>
          </div>
          <p class="tips">为保障你的资金安全，请通过手机短信验证后，完成提现</p>
          <div class="getcode">
            <div class="phone">
              <p>手机号码</p><input type="number" readonly @input="phoneChange" v-model="phone" value="phone">
            </div>
            <span style="display:block;padding:2px 17px;color:red;font-size:12px;" v-if="truePhone">请输入正确手机号</span>
            <div class="code">
              <p>验证码</p><input type="number" v-model="msgCode">
              <button type="button" ref='getCode' :disabled='canGet' @click="countDown()">发送验证码</button>
            </div>
          </div>
          <div class="overBtn" :disabled='canGet' @click="payOver()">完成提现</div>
        </div>
      </div>
    </div>
    <!-- 成功页 -->
    <mt-popup v-model="popupVisible" position="right">
       <div id="alert">
         <mt-header title="提交申请">
           <mt-button slot="right" @click.native="hidenPopup()">完成</mt-button>
         </mt-header>
         <h1><icon name='check-circle'></icon>提现申请已提交</h1>
         <p>提现申请已提交，请等待支付宝处理。预计3~7个工作日内到账。如您填写信息有误，导致转出失败，资金将退回账户。</p>
         <div @click="hidenPopup()">知道了</div>
       </div>
     </mt-popup>
  </div>
</template>

<script>
import Geetest from '../assets/js/gt'
import { Toast } from 'mint-ui'
var captcha = null
export default {
  name: 'withdraw',
  data () {
    return {
      account: '',
      zfbName: '',
      money: '',
      phone: this.STATE.state.loginPhone,
      tmpGeetest: Geetest,
      // 全部余额
      allMoney: this.$route.query.money,
      // 可提现的金额
      takeMoney: '0',
      // 获取验证码按钮是否失效
      canGet: true,
      // 倒数60s
      time: 60,
      // 显示错误
      truePhone: false,
      // 完成页
      popupVisible: false,
      msgCode: ''
    }
  },
  mounted () {
    this.allMoney = this.$route.query.money
    if (this.allMoney < 20) {
      this.takeMoney = 0
    } else if (this.allMoney > 50000) {
      this.takeMoney = 50000
    } else {
      this.takeMoney = this.allMoney
    }
    if (this.STATE.state.loginPhone !== 0) {
      this.canGet = false
    }
    this.initGeetested()
  },
  methods: {
    initGeetested () {
      var _this = this
      this.axios.get('/url/common/fastRegister?t=' + (new Date()).getTime())
      .then(function (data) {
        window.initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captcha = captchaObj
          captchaObj.onReady(function () {
            console.log('onReady==========')
          }).onSuccess(function () {
            var result = captchaObj.getValidate()
            if (result) {
              _this.getCodeFromBack(result)
            } else {
              alert('验证失败')
            }
          })
        })
      })
    },
    validateSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.money > 50000 || this.money < 20 || parseFloat(this.money) > parseFloat(this.allMoney)) {
            Toast({
              message: '提现金额有问题',
              position: 'middle',
              duration: 1000
            })
            return
          }
          this.$refs.minContent.style.animation = 'nextPage 0.5s linear forwards'
          this.$refs.minContent.style.WebkitAnimation = 'nextPage 0.5s linear forwards'
        }
      })
    },
    prevBtn: function () {
      this.$refs.minContent.style.animation = 'prevPage 0.5s linear forwards'
      this.$refs.minContent.style.WebkitAnimation = 'prevPage 0.5s linear forwards'
    },
    moneyBtn: function () {
      this.money = this.takeMoney
    },
    phoneChange: function () {
      var reg = /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      var bol = reg.test(this.phone)
      if (bol) {
        this.canGet = false
        this.truePhone = false
      } else {
        this.canGet = true
        this.truePhone = true
      }
    },
    countDown: function () {
      captcha.verify()
    },
    getCodeFromBack: function (result) {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/common/getWechatVerificationCode/4',
        params: {
          moblie: this.phone,
          challenge: result.geetest_challenge,
          validate: result.geetest_validate,
          seccode: result.geetest_seccode
        }
      }).then(function (response) {
        let msg = ''
        if (response.data.success) {
          msg = '发送成功'
          _this.runCode()
        } else {
          msg = response.data.msg
        }
        Toast({
          message: msg,
          position: 'middle',
          duration: 1000
        })
      }).catch(function (response) {
        Toast({
          message: '发送失败',
          position: 'middle',
          duration: 1000
        })
      })
    },
    runCode: function () {
      if (this.time === 0) {
        this.$refs.getCode.removeAttribute('disabled')
        this.$refs.getCode.innerHTML = '获取验证码'
        this.time = 60
      } else {
        this.$refs.getCode.setAttribute('disabled', true)
        this.$refs.getCode.innerHTML = this.time + '秒后获取'
        this.time --
        setTimeout(this.runCode, 1000)
      }
    },
    payOver: function () {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/fund/withdraw',
        params: {
          alipayAccount: this.account,
          alipayName: this.zfbName,
          count: this.money,
          msgCode: this.msgCode,
          _method: 'PUT'
        }
      }).then(function (response) {
        let msg = ''
        if (response.data.success) {
          _this.popupVisible = true
        } else {
          msg = response.data.msg
          Toast({
            message: msg,
            position: 'middle',
            duration: 1000
          })
        }
      }).catch(function (response) {
        Toast({
          message: '提交失败',
          position: 'middle',
          duration: 1000
        })
      })
    },
    hidenPopup: function () {
      this.$router.go(-1)
      // this.popupVisible = false
    }
  }
}
</script>

<style scoped>
  .content_wrap{
    width:100%;
    height:100%;
    overflow:hidden;
  }
  .content{
    width:200%;
    height:100%;
    position:relative;
    animation-fill-mode:forwards;
    -webkit-animation-fill-mode:forwards;
    overflow: hidden;
  }
  .part_one,.part_two{
    width:50%;
    float:left;
  }
  .part_one .title{
    background-color: #26a2ff;
    padding:21px 18px 15px;
  }
  .part_one .title p{
    font-size: 15px;
    color: #abddff;
  }
  .part_one .title span{
    font-size: 30px;
    color: #fff;
    margin: 10px 0;
  }
  .part_one .title .prompt{
    margin-top: 10px;
    background-color: #fff;
    padding: 10px 25px 5px;
    box-sizing: border-box;
    -webkit-border-radiu:30px;
    -moz-border-radiu:30px;
    border-radius:30px;
    text-align: center;
  }
  .part_one .title .prompt span{
    font-size: 12px;
    color: #006fff;
    vertical-align: top;
  }
  .part_one .title .prompt .fa-icon{
    color: #006fff;
  }
  .part_one form{
    padding-top:6px; 
    margin-bottom:68px;
    background-color:#f0eff5;
  }
  .zfb_account{
    border-top:1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
  .zfb_name{
    border-bottom:1px solid #ccc;
  }
  .zfb_account,.zfb_name{
    background-color: #fff;
    line-height: 39px;
    padding:0 17px;
    display: table;
    width: 100%;
    box-sizing: border-box;
  }
  .zfb_account p,.zfb_name p{
    display: table-cell;
    font-size: 14px;
  }
  .zfb_account input,.zfb_name input{
    display: table-cell;
    width: 100%;
    border: none;
    outline: none;
  }
  .money{
    background-color: #fff;
    margin-top: 10px;
    padding:13px 14px;
  }
  .money .money_title{
    margin-left: 5px;
    font-size: 14px;
  }
  .money .set{
    border-bottom: 1px solid #ccc;
    line-height: 45px;
  }
  .money .set label{
    font-size: 23px;
    font-weight: bold;
    margin:0 6px;
  }
  .money .set input{
    font-size: 23px;
    outline: none;
    border: none;
  }
  .money .can span{
    font-size: 12px;
    color: #b2b2b2;
  }
  .money .can p{
    color:#0f90e7;
    float: right;
    font-size:12px;
    margin-top: 4px;
  }
  .tips{
    font-size: 12px;
    padding: 5px 17px;
    color: #808080;
  }
  .part_one .primary{
    display: block;
    width: 90%;
    margin: 5px auto 0;
    line-height: 30px;
    background-color: #108ee9;
    color: #fff;
    text-align:center;
    font-size: 15px;
    -webkit-border-radiu:20px;
    -moz-border-radiu:20px;
    border-radius:20px;
    border: none;
    outline:none;
  }
  .help{
    display:block;
    width:80%;
    margin:0 auto;
    font-size:14px;
    color:red;
  }
  @-webkit-keyframes "nextPage"{
	0%{
		left:0;
		}
	100%{left:-100%;}
}
@keyframes "nextPage"{
	0%{
		left:0;
		}
	100%{left:-100%;}
}
@-webkit-keyframes "prevPage"{
	0%{
		left:-100%;
		}
	100%{left:0;}
}
@keyframes "prevPage"{
	0%{
		left:100%;
		}
	100%{left:0;}
}
.part_two .info{
  background-color: #f0eff5;
}
.part_two .info div{
  overflow: hidden;
  padding: 0 17px;
  line-height: 39px;
  border-bottom:1px solid #ccc;
  background-color: #fff;
}
.part_two .info div p{
  float: left;
}
.part_two .info div p:nth-child(1){
  font-size: 14px;
  width: 80px;
}
.part_two .info div p:nth-child(2){
  font-size: 12px;
  color: #808080;
}
.part_two .tips{
  font-size: 12px;
  color: #808080;
  text-align: center;
  background-color: #f0eff5;
  padding: 5px 0;
}
.part_two .getcode{
  border-top: 1px solid #ccc;
}
.part_two .getcode div{
  border-bottom: 1px solid #ccc;
  padding: 0 17px;
  line-height: 39px;
}
.part_two .getcode div p{
  display: inline-block;
  width: 80px;
}
.part_two .getcode .phone{
  display: table;
  width: 100%;
  box-sizing: border-box;
}
.part_two .getcode .phone p{
  display: table-cell;
}
.part_two .getcode .phone input{
  width: 100%;
  display: table-cell;
  outline:none;
  border: none;
}
.part_two .getcode .code input{
  width: 35%;
  outline:none;
  border: none;
}
.part_two .getcode .code button{
  float: right;
  padding:2px 10px;
  background-color: #108ee9;
  color: #fff;
  margin-top: 8px;
  outline:none;
  border: none;
  -webkit-border-radiu:10px;
  -moz-border-radiu:10px;
  border-radius:10px;
}
.overBtn{
  width: 90%;
  margin: 70px auto 0;
  line-height: 40px;
  background-color: #108ee9;
  color: #fff;
  text-align:center;
  font-size: 15px;
   -webkit-border-radiu:20px;
  -moz-border-radiu:20px;
  border-radius:20px;
}  
.mint-popup{
  width: 100%;
  height: 100%;
}
#alert{
  height: 100%;
}
#alert h1{
  margin-top: 50%;
  text-align: center;
  transform: translateY(-50%);
  -moz-transform:translateY(-50%);
  -o-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  font-size: 24px;
}
#alert h1 .fa-icon{
  transform: scale(1.5);
  margin-right: 10px;
  color:#108ee9;
}
#alert p{
  padding: 0 40px;
  font-size: 14px;
  text-indent: 28px;
}
#alert div{
  width: 100%;
  line-height: 40px;
  color: #fff;
  background-color:#108ee9;
  text-align: center;
  position: fixed;
  bottom:0;
}
</style>


// WEBPACK FOOTER //
// withdraw.vue?491d4f32